module.exports = __webpack_public_path__ + "img/storage-remove.56c92490.svg";